import "@/App.css";
import "@/marketing-v2.css";
import "@/admin.css";
import { HashRouter, Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { SiteHeader } from "./components/SiteHeader";
import { SiteFooter } from "./components/SiteFooter";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import ProjectsPage from "./pages/ProjectsPage";
import PolicyPage from "./pages/PolicyPage";
import AuthCallbackPage from "./pages/admin/AuthCallbackPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminOverviewPage from "./pages/admin/AdminOverviewPage";
import AdminProjectsPage from "./pages/admin/AdminProjectsPage";
import ProjectEditorPage from "./pages/admin/ProjectEditorPage";
import AdminClientsPage from "./pages/admin/AdminClientsPage";
import AdminServicesPage from "./pages/admin/AdminServicesPage";
import AdminSettingsPage from "./pages/admin/AdminSettingsPage";
import AdminAccessPage from "./pages/admin/AdminAccessPage";
import AdminCoverPage from "./pages/admin/AdminCoverPage";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { lockScrollToTop } from "./lib/scroll";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => lockScrollToTop(), [pathname]);
  return null;
};

const PublicLayout = () => (
  <div className="site-shell">
    <ScrollToTop />
    <SiteHeader />
    <Routes><Route path="/" element={<HomePage />} /><Route path="/about" element={<AboutPage />} /><Route path="/services" element={<ServicesPage />} /><Route path="/projects" element={<ProjectsPage />} /><Route path="/contact" element={<ContactPage />} /><Route path="/projects/:slug" element={<ProjectDetailPage />} /><Route path="/policies/:slug" element={<PolicyPage />} /><Route path="*" element={<main className="v2-public v2-not-found" data-testid="public-route-not-found"><span>404</span><h1>Page not found.</h1><p>The requested page is not available.</p><Link to="/" className="v2-button-primary">Return home</Link></main>} /></Routes>
    <SiteFooter />
  </div>
);

const AppRoutes = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return <AuthProvider><Routes>
    <Route path="/admin/login" element={<AdminLoginPage />} />
    <Route path="/admin" element={<AdminLayout />}>
      <Route index element={<AdminOverviewPage />} />
      <Route path="projects" element={<AdminProjectsPage />} />
      <Route path="projects/new" element={<ProjectEditorPage />} />
      <Route path="projects/:projectId" element={<ProjectEditorPage />} />
      <Route path="cover" element={<AdminCoverPage />} />
      <Route path="clients" element={<AdminClientsPage />} />
      <Route path="services" element={<AdminServicesPage />} />
      <Route path="settings" element={<AdminSettingsPage />} />
      <Route path="access" element={<AdminAccessPage />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Route>
  </Routes></AuthProvider>;
  return <PublicLayout />;
};

function App() {
  if (window.location.hash.includes("session_id=")) return <AuthCallbackPage />;
  return <HashRouter><AppErrorBoundary><AppRoutes /></AppErrorBoundary><Toaster richColors position="top-right" /></HashRouter>;
}

export default App;
